import { groupEntityName } from '../../../../../../backend/features/groups/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../../ui/hooks';
import { DataTable, TextCell, useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { useEntityDataTable } from '@juvare/platform-sdk-react/ui/hooks';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { mapGroupFilter } from '../../../hooks/useGroupList';
import { useGroupsFilterConfig } from '../../../hooks/useGroupsFilterConfig';
export function showGroupsDialog(params) {
    showCustomDialog({
        fullWidth: true,
        maxWidth: 'md',
        content: (close) => React.createElement(GroupsDialogComponent, Object.assign({}, params, { close: close })),
    });
}
export const GroupsDialogComponent = (props) => {
    var _a;
    const userState = useUserState();
    const { t } = useContactManagementTranslation();
    const columns = React.useMemo(() => [
        {
            headerLabel: t('panels.groups.name'),
            cellFunction: (row) => React.createElement(TextCell, null, row.columns.name),
            sortKey: 'name',
        },
    ], [t]);
    const { dataTableProps } = useEntityDataTable({
        title: '',
        entityName: groupEntityName,
        mapEntityFilterData: (filterData) => mapGroupFilter(userState, filterData, !props.excludeFilterBasedGroups, props.selectedGroupId),
        filterConfig: useGroupsFilterConfig(),
        columns: columns,
        defaultSortColumnKey: 'name',
    }, {
        useDataTableFunction: useDataTableUsingState,
        onRowClick: props.enableRowSelection ? undefined : () => undefined,
        rowSelectionEnabled: props.enableRowSelection,
        initialSelectedRowIds: props.selectedGroupIds,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('panels.groups.selectGroup')),
        React.createElement(DialogContent, null, userState && React.createElement(DataTable, Object.assign({}, dataTableProps, { "data-test": 'groups-table' }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => props.close() }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', disabled: props.enableRowSelection ? !((_a = dataTableProps.selectedRowIds) === null || _a === void 0 ? void 0 : _a.length) : !dataTableProps.activeRowId, onClick: () => {
                    props.close(() => {
                        var _a;
                        if (dataTableProps.activeRowId) {
                            props.onSelect(dataTableProps.activeRowId);
                        }
                        else if ((_a = dataTableProps.selectedRowIds) === null || _a === void 0 ? void 0 : _a.length) {
                            props.onSelect(dataTableProps.selectedRowIds);
                        }
                    });
                } }, t('common.select')))));
};
